import React, { useEffect, useState } from 'react'
import { useReactToPrint } from 'react-to-print';
import { IoIosPrint } from "react-icons/io";
import { IsMobileEnv } from '../../../../configurations/initUrls';
//import printIonicContent from '../../../../configurations/native/ionicPrint';

export function PrintStarter({ item, setPrintData, printRef, color = "success", title }) {
    const [printCount, setPrintCount] = useState(0)

    useEffect(() => {
        if (printCount > 0 && item) {
            // if (IsMobileEnv)
            //     //printIonicContent(printRef.current.outerHTML)
            // else
                handlePrint()
        }
    }, [printCount])
    const handlePrint = useReactToPrint({
        contentRef: printRef,
    });
    const initPrint = () => { setPrintData({ ...item }); setPrintCount(printCount + 1) }
    return (
        <botton onClick={initPrint} className={`btn-${color}`} title={title}><IoIosPrint /></botton>
    )
}
